import { PrimaryButton } from '@/srp/Button';
import { useIsMobile } from '~/context/common/DeviceContext';
import useLogInAndSaveSearch from '~/hooks/srp/useLogInAndSaveSearch';
import {
  CustomIcon,
  FlexContainer,
  FlexPanel,
  FullWidthFlexPanel,
  TextAndIconPanel,
  TileSubtitle,
  TileTitle
} from './SaveSearchTile.styles';

const SaveSearchTile = () => {
  const isMobile = useIsMobile();

  const handleSaveSearch = useLogInAndSaveSearch();

  const tileText = isMobile ? 'Save your search' : 'Save your \n search';
  const subtitleText = isMobile
    ? 'Matching vehicles straight to your inbox. Over 1,000 added every day!'
    : 'Matching vehicles straight to your inbox.\n Over 1,000 added every day!';

  return (
    <FlexContainer data-qa="save-search-tile">
      <FlexPanel>
        <TextAndIconPanel>
          <CustomIcon />
          <div>
            <TileTitle>{tileText}</TileTitle>
            <TileSubtitle>{subtitleText}</TileSubtitle>
          </div>
        </TextAndIconPanel>
        <FullWidthFlexPanel>
          <PrimaryButton
            size="small"
            onClick={handleSaveSearch}
            data-analytics-id="Save Search Tile - Create Saved Search"
            data-qa="custom-button"
          >
            Save this search
          </PrimaryButton>
        </FullWidthFlexPanel>
      </FlexPanel>
    </FlexContainer>
  );
};

export default SaveSearchTile;
